  $(document).on('submit','form.custom-filter',function(e){
    e.preventDefault();
    var target = $(this).attr('action') + '/';
    $('select.cm_select_inner-select').each(function (){
       if($(this).val()){
        target +=  $(this).val() + "+" ;
       }
    })
    window.location.href = target.slice(0,-1);
  });

  $(document).on('click','.cm_vehicle-widget_button.cm_vehicle-widget_button__clear', function(){
    location.reload();
  })

  // jQuery_T4NT(document).ready(function($) {
  
  //      /**
  //      * Variant selection changed
  //      */
  // 	  $( document ).on( "variant:change", function( evt, variant ) {
  // 	    //console.log( variant );
  // 	  });
  
  // });


